import React from 'react'
import './header.css'
import ME from '../../assets/logo.png'
import HeaderSocials from './HeaderSocials'
import TextScrambler from 'react-scramble-text'
import 'react-scramble-text/dist/index.css'
import {AiOutlineArrowRight} from 'react-icons/ai'

const Header = () => {
  const phrases = ["{Better Development}", "{Better Experience}"]
  return (
    <header>
      <div className="container header__container">
        <h5>Welcome to,</h5>
        <h1>KH DEVELOPMENT</h1>
        <h5 className="text-light">
        <TextScrambler phrases={phrases} speed={5} pauseTime={2000}/>
        </h5>
        <HeaderSocials/>

          <div className="me">
            <img src={ME} alt="" />
          </div>


        <a href="#contact" className='scroll__down'>Scroll Down   <AiOutlineArrowRight className='scroll__down-icon'/></a>
      </div>
    </header>
  )
}

export default Header